import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { LangProvider } from "@/i18n";
import { scrollToId } from "@/data/content";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => scrollToId(hash), 150);
    } else {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <HelmetProvider>
      <LangProvider>
        <BrowserRouter>
          <ScrollManager />
          <div className="App bg-[#0B0E14]">
            <div className="noise-overlay" />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
            </Routes>
            <Footer />
            <FloatingWhatsApp />
            <Toaster position="bottom-left" theme="dark" />
          </div>
        </BrowserRouter>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
